/*
 * Koforto 变体选择器 <kf-picker>（两种样式共用一个逻辑）
 *   data-mode="tank"     内衣：先选件数（1 / 3 / 6 件…），选中的那档展开「每件颜色 + 尺码」下拉，可带赠品
 *   data-mode="blanket"  毯子：先选颜色色块 + 尺码按钮，再选件数，选中的那档展开「#1 #2 … 颜色 + 尺码」下拉
 * 渲染：snippets/kf-picker-tank.liquid / snippets/kf-picker-blanket.liquid
 * 价格只做展示；真实折扣、赠品免单需要在 Shopify 后台建自动折扣。
 * 对外事件：kf:change  detail = { qty, variants, total }
 */
(function () {
  if (customElements.get('kf-picker')) return;

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    const fmt = format || '£{{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const d = (n, p, t = ',', dec = '.') => {
      const parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    };
    const m = fmt.match(re);
    if (!m) return (cents / 100).toFixed(2);
    const v = {
      amount_no_decimals: () => d(cents, 0),
      amount_with_comma_separator: () => d(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => d(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => d(cents, 2, "'", '.'),
    }[m[1]];
    return fmt.replace(re, v ? v() : d(cents, 2));
  }
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const colorMapOf = (text) => {
    const map = {};
    (text || '').split(/\n|,/).forEach((l) => { const i = l.indexOf(':'); if (i > 0) map[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim(); });
    return map;
  };

  class KfPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.d = JSON.parse(this.querySelector('[data-kp-json]').textContent); } catch (e) { console.error('[kf-picker] bad json', e); return; }
      const d = this.d;
      this.mode = this.dataset.mode;
      this.colorMap = colorMapOf(d.colorMap);
      this.ci = d.colorIndex; this.si = d.sizeIndex;
      this.btn = this.querySelector('[data-kp-buy]');
      this.err = this.querySelector('[data-kp-error]');
      this.tiers = [...this.querySelectorAll('[data-kp-tier]')];

      const start = d.variants.find((v) => v.id === d.selected && v.available) || d.variants.find((v) => v.available) || d.variants[0];
      this.base = start.options.slice();
      // 后台设置的默认颜色 / 尺码（不区分大小写；该组合无货时自动退回可买的款式）
      const pick = (idx, want) => {
        if (idx < 0 || !want) return;
        const v = (d.options[idx] && d.options[idx].values || []).find((x) => x.name.toLowerCase() === String(want).trim().toLowerCase());
        if (v) this.base[idx] = v.name;
      };
      pick(this.ci, d.defColor); pick(this.si, d.defSize);
      if (d.defColor || d.defSize) this.base = this.fix(this.base);
      this.items = [];
      this.tierIndex = Math.min(Math.max(0, d.defaultTier), this.tiers.length - 1);

      // 毯子：顶部颜色 / 尺码
      this.querySelectorAll('[data-kp-swatch]').forEach((b) => b.addEventListener('click', () => this.setBase(this.ci, b.dataset.value)));
      this.querySelectorAll('[data-kp-size]').forEach((b) => b.addEventListener('click', () => this.setBase(this.si, b.dataset.value)));
      this.paintSwatches();

      this.tiers.forEach((t, i) => {
        const r = t.querySelector('input[type=radio]');
        r.addEventListener('change', () => this.selectTier(i));
      });
      if (this.btn) this.btn.addEventListener('click', () => this.buy());
      this.shopPay = this.querySelector('[data-kp-shoppay]');
      if (this.shopPay) this.shopPay.addEventListener('click', () => this.buy(true));
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.setBusy(false); });
      this.renderShip();
      this.selectTier(this.tierIndex, true);
      this.initSizeFinder();
    }

    /* ---------- 尺码查询：底围 + 罩杯 → 推荐尺码，应用到每一件 ---------- */
    setSizeAll(value) {
      if (this.si < 0) return false;
      const opt = ((this.d.options[this.si] || {}).values || []).find((x) => x.name.toLowerCase() === String(value).trim().toLowerCase());
      if (!opt) return false;
      this.base[this.si] = opt.name; this.base = this.fix(this.base);
      this.items = this.items.map((o) => { const n = o.slice(); n[this.si] = opt.name; return this.fix(n); });
      this.paintSwatches(); this.renderItems(); this.update();
      return opt.name;
    }
    initSizeFinder() {
      const sf = this.querySelector('[data-kf-sf]');
      if (!sf || this.si < 0) { if (sf) sf.hidden = true; return; }
      const $ = (q) => sf.querySelector(q);
      const wSel = $('[data-sf-weight]'), cSel = $('[data-sf-cup]'), size = $('[data-sf-size]'), note = $('[data-sf-note]');
      const ds = sf.dataset, st = ds.unit === 'st';
      ((this.d.options[this.si] || {}).values || []).forEach((v) => size.add(new Option(v.name, v.name)));
      const say0 = (t, warn) => { if (!note) return; note.textContent = t || ''; note.hidden = !t; note.classList.toggle('is-warn', !!warn); };
      // 文胸模式：底围 + 罩杯 → 查对照表（每行一个罩杯，每格一个底围）
      if (ds.mode === 'bra') {
        const bSel = $('[data-sf-band]');
        const rows = (ds.matrix || '').split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).filter((r) => r.length > 1);
        const calcB = () => {
          if (!bSel || bSel.value === '' || cSel.value === '') return;
          let v = (rows[+cSel.value] || [])[+bSel.value];
          if (!v || v === '-') { size.value = ''; say0(ds.none, true); return; }
          const snug = /\*$/.test(v); v = v.replace(/\*$/, '').trim();   // 格子末尾带 * = 已是最大码，显示 sf_max_note
          const name = this.setSizeAll(v);
          size.value = name || '';
          say0(snug ? (ds.max || ds.note) : ds.note, snug);
        };
        [bSel, cSel].forEach((el) => el && el.addEventListener('change', calcB));
        size.addEventListener('change', () => { if (size.value) this.setSizeAll(size.value); });
        return;
      }
      // 体重表（kg）："M:40-47, L:47-57, …"
      const ranges = (ds.ranges || '').split(',').map((x) => { const m = x.trim().match(/^(.+?)\s*:\s*([\d.]+)\s*-\s*([\d.]+)$/); return m && { size: m[1].trim(), a: +m[2], b: +m[3] }; }).filter(Boolean);
      if (!ranges.length) { sf.hidden = true; return; }
      const hi = ranges[ranges.length - 1].b, margin = Math.max(0, +ds.margin || 0), big = +ds.big;
      const LB = 0.45359237;
      // 英石缩写（英国常用写法）：9st 4 = 9 英石 4 磅；整英石只写 9st
      const lbLabel = (lb) => (lb % 14 ? `${Math.floor(lb / 14)}st ${lb % 14}` : `${lb / 14}st`);
      const wl = (kg) => (st ? lbLabel(Math.round(kg / LB)) : `${+kg.toFixed(1)}`);
      const span = (x, y) => (st ? `${wl(x)}–${wl(y)}` : `${wl(x)}–${wl(y)} kg`);
      // 每个尺码区间在「上限 − 余量」处切成两段（最大码不切）：value = 尺码序号:是否过线
      const segs = [];
      ranges.forEach((r, k) => {
        const line = r.b - margin;
        if (margin > 0 && line > r.a && k < ranges.length - 1) { segs.push({ a: r.a, b: line, v: `${k}:0` }); segs.push({ a: line, b: r.b, v: `${k}:1` }); }
        else segs.push({ a: r.a, b: r.b, v: `${k}:0` });
      });
      // 推荐结果（普通罩杯 / 偏大罩杯）完全相同的相邻档自动合并，下拉更短
      const res = (v, bigCup) => { const [k, o] = v.split(':').map(Number); return (o || bigCup) && ranges[k + 1] ? ranges[k + 1].size : ranges[k].size; };
      const merged = [];
      segs.forEach((g) => {
        const last = merged[merged.length - 1];
        if (last && res(last.v, 0) === res(g.v, 0) && res(last.v, 1) === res(g.v, 1)) { last.b = g.b; last.v = g.v; }
        else merged.push({ ...g });
      });
      // 没有「超出」选项时，最后一档不设上限（如「90 kg +」）
      merged.forEach((g, n) => wSel.add(new Option(!ds.none && n === merged.length - 1 ? (st ? `${wl(g.a)} +` : `${wl(g.a)} kg +`) : span(g.a, g.b), g.v)));
      if (ds.none) wSel.add(new Option(st ? `${wl(hi)} +` : `${wl(hi)} kg +`, 'over')); // 「超出」选项只在填了提示文字时显示
      const say = (t, warn) => { if (!note) return; note.textContent = t || ''; note.hidden = !t; note.classList.toggle('is-warn', !!warn); };
      const calc = () => {
        if (wSel.value === '' || cSel.value === '') return;
        if (wSel.value === 'over') { size.value = ''; say(ds.none, true); return; }
        const [i, over] = wSel.value.split(':').map(Number);
        // 过线 或 罩杯偏大 → 大一码（最多一码）
        const up = over === 1 || +cSel.value >= big;
        let pick = ranges[i].size, warn = false;
        if (up) { if (ranges[i + 1]) pick = ranges[i + 1].size; else warn = true; }
        const name = this.setSizeAll(pick);
        size.value = name || '';
        say(warn ? ds.max : ds.note, warn);
      };
      [wSel, cSel].forEach((el) => el.addEventListener('change', calc));
      size.addEventListener('change', () => { if (size.value) this.setSizeAll(size.value); });
    }

    /* ---------- 数据 ---------- */
    find(opts) { return this.d.variants.find((v) => v.options.every((o, i) => o === opts[i])); }
    available(opts, idx, value) {
      const o = opts.slice(); o[idx] = value;
      return this.d.variants.some((v) => v.available && v.options.every((x, i) => x === o[i]));
    }
    // 某个选项值不可用时，就近换成可用组合
    fix(opts) {
      if ((this.find(opts) || {}).available) return opts;
      const v = this.d.variants.find((x) => x.available && (this.ci < 0 || x.options[this.ci] === opts[this.ci])) || this.d.variants.find((x) => x.available);
      return v ? v.options.slice() : opts;
    }
    tierData(i) { return this.d.tiers[i]; }
    unitStrike(v) { return this.d.strike === 'price' ? v.price : Math.max(v.compare || 0, v.price); }
    priceFor(variants, tier) {
      const sum = variants.reduce((a, v) => a + (v ? v.price : 0), 0);
      let was = variants.reduce((a, v) => a + (v ? this.unitStrike(v) : 0), 0);
      let now = sum;
      if (tier.total > 0) now = tier.total;
      else if (tier.pay > 0 && tier.pay < tier.qty) now = Math.round((sum * tier.pay) / tier.qty);
      // 与 Shopify 百分比折扣一致：每件折扣金额向下取整到分，再相加
      else if (tier.off > 0) now = sum - variants.reduce((a, v) => a + (v ? Math.floor((v.price * tier.off) / 100 + 1e-9) : 0), 0);
      // 捆绑套餐模式：划线价回退到单价 × 件数（不是 compare_at_price × qty）
      if (tier.total > 0 && this.d.strike === 'unit') was = sum;
      return { now, was };
    }

    /* ---------- 交互 ---------- */
    setBase(idx, value) {
      if (idx < 0) return;
      this.base[idx] = value;
      this.base = this.fix(this.base);
      // 顶部改颜色/尺码 → 所有件同步（内衣：只改这一项，每件已选的尺码保留）
      this.items = this.mode === 'tank'
        ? this.items.map((o) => { const n = o.slice(); n[idx] = this.base[idx]; return this.fix(n); })
        : this.items.map(() => this.base.slice());
      this.paintSwatches();
      this.renderItems();
      this.update();
    }
    selectTier(i, initial) {
      this.tierIndex = i;
      const t = this.tierData(i);
      this.tiers.forEach((el, k) => {
        el.classList.toggle('is-active', k === i);
        el.querySelector('input[type=radio]').checked = k === i;
      });
      // 保留已选的件，不够就补（内衣：新增件换下一个颜色，方便凑不同色）
      const next = [];
      for (let n = 0; n < t.qty; n++) {
        if (this.items[n]) { next.push(this.items[n]); continue; }
        let o = (next[n - 1] || this.base).slice();
        if (n > 0 && this.mode === 'tank' && this.ci > -1 && this.d.vary) {
          const colors = this.d.options[this.ci].values.map((v) => v.name);
          const start = colors.indexOf(o[this.ci]);
          for (let s = 1; s <= colors.length; s++) {
            const c = colors[(start + s) % colors.length];
            if (this.available(o, this.ci, c)) { o[this.ci] = c; break; }
          }
        }
        next.push(this.fix(o));
      }
      this.items = next;
      this.renderItems();
      this.update();
    }

    swatchStyle(name, photo) {
      const opt = this.d.options[this.ci];
      const val = opt && opt.values.find((v) => v.name === name);
      // 内衣色块：优先用该颜色变体的商品图
      if (photo) { const pv = this.d.variants.find((v) => v.options[this.ci] === name && v.image); if (pv) return `background-image:url('${pv.image}')`; }
      if (val && val.img) return `background-image:url('${val.img}')`;
      const hex = (val && val.hex) || this.colorMap[String(name).toLowerCase()];
      if (hex) return `background:${hex}`;
      // 没设颜色色值时，退回用该颜色变体的商品图（9 层毯子等未配置 Shopify 色块的商品）
      const fv = this.d.variants.find((v) => v.options[this.ci] === name && v.image);
      return fv ? `background-image:url('${fv.image}');background-size:cover;background-position:center` : '';
    }
    paintSwatches() {
      this.querySelectorAll('[data-kp-swatch]').forEach((b) => {
        const on = this.base[this.ci] === b.dataset.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
        b.classList.toggle('is-out', !this.available(this.base, this.ci, b.dataset.value));
        if (!b.dataset.painted) { const st = this.swatchStyle(b.dataset.value, !!b.closest('[data-kp-photo]')); if (st) b.querySelector('i').setAttribute('style', st); b.dataset.painted = 1; }
      });
      this.querySelectorAll('[data-kp-size]').forEach((b) => {
        const on = this.base[this.si] === b.dataset.value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
        b.classList.toggle('is-out', !this.available(this.base, this.si, b.dataset.value));
      });
      const cl = this.querySelector('[data-kp-colour-name]'); if (cl && this.ci > -1) cl.textContent = this.base[this.ci];
      const sl = this.querySelector('[data-kp-size-name]'); if (sl && this.si > -1) sl.textContent = this.base[this.si];
    }

    selectHtml(n, idx) {
      const opt = this.d.options[idx];
      const cur = this.items[n][idx];
      const opts = opt.values.map((v) => {
        const ok = this.available(this.items[n], idx, v.name);
        return `<option value="${esc(v.name)}"${v.name === cur ? ' selected' : ''}${ok ? '' : ' disabled'}>${esc(v.name)}${ok ? '' : ' – sold out'}</option>`;
      }).join('');
      return `<label class="kfp-select"><span class="visually-hidden">${esc(opt.name)} ${n + 1}</span><select data-n="${n}" data-idx="${idx}">${opts}</select></label>`;
    }
    renderItems() {
      const host = this.tiers[this.tierIndex] && this.tiers[this.tierIndex].querySelector('[data-kp-items]');
      this.tiers.forEach((t) => { const h = t.querySelector('[data-kp-items]'); if (h && h !== host) h.innerHTML = ''; });
      if (!host) return;
      const idxs = this.d.options.map((o, i) => i).filter((i) => this.d.options[i].values.length > 1);
      if (!idxs.length) { host.hidden = true; return; }
      // 毯子：1 件档不展开（顶部已选颜色尺码），2 件及以上才逐件选
      if (this.mode !== 'tank' && this.items.length < 2) { host.innerHTML = ''; host.hidden = true; return; }
      host.hidden = false;
      host.innerHTML = this.items.map((o, n) => {
        const v = this.find(o) || {};
        const lead = this.mode === 'tank'
          ? `<span class="kfp-row__img">${v.image || this.d.image ? `<img src="${esc(v.image || this.d.image)}" alt="" width="64" height="80" loading="lazy">` : ''}</span>`
          : `<span class="kfp-row__n">#${n + 1}</span>`;
        return `<div class="kfp-row">${lead}${idxs.map((i) => this.selectHtml(n, i)).join('')}</div>`;
      }).join('');
      host.querySelectorAll('select').forEach((s) => s.addEventListener('change', () => {
        const n = +s.dataset.n;
        const o = this.items[n].slice(); o[+s.dataset.idx] = s.value;
        this.items[n] = this.fix(o);
        this.renderItems();
        this.update();
      }));
    }

    update() {
      const fmt = this.d.moneyFormat;
      const variants = this.items.map((o) => this.find(o));
      // 各档位价格：选中档按实际所选，其余档按顶部默认选择预览
      this.tiers.forEach((el, k) => {
        const t = this.tierData(k);
        const vs = k === this.tierIndex ? variants : Array.from({ length: t.qty }, () => this.find(this.base));
        const p = this.priceFor(vs, t);
        const now = el.querySelector('[data-kp-now]'); if (now) now.textContent = formatMoney(p.now, fmt);
        const was = el.querySelector('[data-kp-was]');
        if (was) { was.textContent = formatMoney(p.was, fmt); was.hidden = !(p.was > p.now); }
        // 单价模式（简洁列表）：大字 = 平均单价；多件档第二行 = 总价 + 划线原价；1 件档在大字旁划线原价
        const q = t.qty || 1;
        const un = el.querySelector('[data-kp-unow]'); if (un) un.textContent = formatMoney(Math.round(p.now / q), fmt);
        const per = el.querySelector('[data-kp-per]'); if (per) per.hidden = q < 2;
        const uw = el.querySelector('[data-kp-uwas]'); if (uw) { uw.textContent = formatMoney(p.was, fmt); uw.hidden = !(q < 2 && p.was > p.now); }
        const tr = el.querySelector('[data-kp-totrow]'); if (tr) tr.hidden = q < 2;
        const sub = el.querySelector('[data-kp-sub]'); if (sub) { const sv = Math.max(0, p.was - p.now); sub.textContent = sub.dataset.tpl.replace('[save]', formatMoney(sv, sv % 100 ? fmt : String(fmt).replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, (_, c) => (c ? '{{amount_no_decimals_with_comma_separator}}' : '{{amount_no_decimals}}')))); }
        const tot = el.querySelector('[data-kp-tot]'); if (tot) tot.textContent = tot.dataset.tpl.replace('[amount]', formatMoney(p.now, fmt));
        const off = el.querySelector('[data-kp-off]');
        if (off) { const pct = p.was > p.now ? Math.floor(((p.was - p.now) / p.was) * 100) : 0; off.hidden = pct < 1; off.textContent = `${pct}% OFF`; }
        const pill = el.querySelector('[data-kp-pill]');
        if (pill) { const save = p.was - p.now; pill.hidden = !(save > 0); if (save > 0) pill.textContent = pill.dataset.label.replace('[amount]', formatMoney(save, fmt)); }
      });
      const t = this.tierData(this.tierIndex);
      const p = this.priceFor(variants, t);
      // 加购推荐：数量跟随所选件数（data-follow），实时更新数量/标题/价格
      this.querySelectorAll('[data-kp-upsell][data-follow]').forEach((u) => {
        const q = t.qty || 1, unit = Number(u.dataset.unit) || 0, unitWas = Number(u.dataset.unitWas) || 0;
        const now = unit * q, was = unitWas * q, save = was - now;
        u.dataset.qty = q; u.dataset.price = now;
        const card = u.closest('.kfp-up');
        card.querySelectorAll('[data-tpl]').forEach((el) => {
          if (el.hasAttribute('data-up-save')) el.textContent = el.dataset.tpl.replace('[amount]', formatMoney(save, fmt));
          else el.textContent = el.dataset.tpl.replace(/\[qty\]/g, q);
        });
        const n = card.querySelector('[data-up-now]'); if (n) n.textContent = formatMoney(now, fmt);
        const w = card.querySelector('[data-up-was]'); if (w) { w.textContent = formatMoney(was, fmt); w.hidden = !(save > 0); }
        const sv = card.querySelector('[data-up-save]'); if (sv) sv.hidden = !(save > 0);
        const qb = card.querySelector('[data-up-qty]'); if (qb) { qb.textContent = q; qb.hidden = q < 2; }
        const ue = card.querySelector('[data-up-unit]'); if (ue) { ue.textContent = `${q} × ${formatMoney(unit, fmt)}`; ue.hidden = q < 2; }
      });
      const ok = variants.every((v) => v && v.available);
      this.variants = variants; this.total = p.now;
      if (this.btn) {
        this.btn.disabled = !ok;
        if (this.shopPay) this.shopPay.disabled = !ok;
        const lbl = this.btn.querySelector('[data-kp-label]');
        if (lbl) lbl.textContent = ok ? this.btn.dataset.label : this.btn.dataset.soldout;
      }
      // 只在第一件的媒体真的变了、且用户视线还在购买区（图库在视口外）时才联动图库，避免滚动跳到图库
      const first = variants[0];
      if (first && first.media && this.d.sectionId && first.media !== this._lastMedia) {
        this._lastMedia = first.media;
        const g = document.querySelector(`media-gallery[id$="${this.d.sectionId}"]`) || document.querySelector('media-gallery');
        if (g && g.setActiveMedia) {
          try {
            // 不滚动：临时屏蔽 window.scrollTo，让 Dawn 的「滚回图库」失效
            const sc = window.scrollTo, sb = Element.prototype.scrollIntoView;
            window.scrollTo = () => {}; Element.prototype.scrollIntoView = function () {};
            // 颜色变体的主图须同时成为图库第一张，而不只是处于激活状态。
            g.setActiveMedia(`${this.d.sectionId}-${first.media}`, true);
            setTimeout(() => { window.scrollTo = sc; Element.prototype.scrollIntoView = sb; }, 80);
          } catch (e) {}
        }
      }
      this.dispatchEvent(new CustomEvent('kf:change', { bubbles: true, detail: { qty: t.qty, variants, total: p.now } }));
      this.dispatchEvent(new CustomEvent('kfx:picker', { bubbles: true, detail: { qty: t.qty, variants, now: p.now, was: Math.max(p.was || 0, p.now) } }));
    }

    renderShip() {
      const el = this.querySelector('[data-kp-ship]');
      if (!el) return;
      let days = +el.dataset.days || 0;
      const dt = new Date();
      while (days > 0) { dt.setDate(dt.getDate() + 1); if (dt.getDay() !== 0 && dt.getDay() !== 6) days--; }
      const txt = dt.toLocaleDateString(el.dataset.locale || document.documentElement.lang || 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      el.querySelectorAll('[data-kp-date]').forEach((s) => (s.textContent = txt));
    }

    /* ---------- 购买 ---------- */
    lineItems() {
      const m = new Map();
      this.variants.forEach((v) => m.set(v.id, (m.get(v.id) || 0) + 1));
      const t = this.tierData(this.tierIndex);
      (this.d.gifts || []).slice(0, t.gifts || 0).forEach((g) => { if (g.available) m.set(g.id, (m.get(g.id) || 0) + 1); });
      this.querySelectorAll('[data-kp-upsell]:checked').forEach((u) => { const id = Number(u.dataset.variant); if (id) m.set(id, (m.get(id) || 0) + (Number(u.dataset.qty) || 1)); });
      /* kfs 移植组件的赠品 / 加购推荐 */
      { const sc = this.closest('[data-kfx-product]') || this.closest('.shopify-section') || document; sc.querySelectorAll('kf-addon[data-on="1"]').forEach((a) => { const id = Number(a.dataset.variant); if (id) m.set(id, (m.get(id) || 0) + (Number(a.dataset.qty) || 1)); }); }
      if (window.kfsExtras) { const scope = this.closest('[data-kfx-product]') || this.closest('.shopify-section') || document; window.kfsExtras(scope).forEach((x) => { if (x.id && !m.has(x.id)) m.set(x.id, x.quantity || 1); }); }
      return [...m].map(([id, quantity]) => ({ id, quantity }));
    }
    setBusy(b) { if (!this.btn) return; this.btn.classList.toggle('is-loading', b); if (b) this.btn.disabled = true; else this.update(); }
    showError(m) { if (this.err) { this.err.textContent = m; this.err.hidden = !m; } }
    track(items) {
      try {
        if (window.fbq) window.fbq('track', 'AddToCart', { content_ids: items.map((i) => String(i.id)), content_type: 'product', num_items: this.tierData(this.tierIndex).qty, value: (this.total + [...this.querySelectorAll('[data-kp-upsell]:checked')].reduce((n, u) => n + (Number(u.dataset.price) || 0), 0)) / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined });
      } catch (e) {}
    }
    async buy(shopPay) {
      if (!this.variants || !this.variants.every((v) => v && v.available)) return;
      this.showError('');
      const items = this.lineItems();
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.setBusy(true);
      if (shopPay || this.dataset.action !== 'cart') {
        this.track(items);
        const params = new URLSearchParams(location.search);
        if (this.dataset.discountCode) params.set('discount', this.dataset.discountCode);
        if (shopPay) params.set('payment', 'shop_pay');
        const qs = params.toString();
        location.href = `${root}cart/${items.map((i) => `${i.id}:${i.quantity}`).join(',')}${qs ? '?' + qs : ''}`;
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = location.pathname;
      }
      try {
        const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to basket');
        this.track(items);
        if (drawer && json.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(json); this.setBusy(false); }
        else location.href = `${root}cart`;
      } catch (e) { this.showError(e.message || 'Something went wrong. Please try again.'); this.setBusy(false); }
    }
  }
  customElements.define('kf-picker', KfPicker);
})();
